import { render, staticRenderFns } from "./myMistakeAnswer.vue?vue&type=template&id=08034a47&scoped=true&"
import script from "./myMistakeAnswer.vue?vue&type=script&lang=js&"
export * from "./myMistakeAnswer.vue?vue&type=script&lang=js&"
import style0 from "./myMistakeAnswer.vue?vue&type=style&index=0&id=08034a47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08034a47",
  null
  
)

export default component.exports